import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=3c4454c8&"
import script from "./ThemeSelector.vue?vue&type=script&lang=js&"
export * from "./ThemeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4454c8')) {
      api.createRecord('3c4454c8', component.options)
    } else {
      api.reload('3c4454c8', component.options)
    }
    module.hot.accept("./ThemeSelector.vue?vue&type=template&id=3c4454c8&", function () {
      api.rerender('3c4454c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ThemeSelector.vue"
export default component.exports